<template>
  <broadcaster-choice>
  </broadcaster-choice>
</template>

<script>
import BroadcasterChoice from '@/components/BroadcasterChoice'
export default {
  name: 'BroadcasterChoiceView',
  components: {
    BroadcasterChoice
  }
}
</script>
